import React from 'react';
import {Link} from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiMail,FiExternalLink,FiHeart}=FiIcons;

function Footer() {
  const currentYear = new Date().getFullYear();
  const quickLinks = [
    {name: 'About', path: '/about'},
    {name: 'Music', path: '/music'},
    {name: 'Shows', path: '/shows'},
    {name: 'Store', path: '/store'}
  ];

  const externalLinks = [
    {name: 'Spotify', url: 'https://open.spotify.com/artist/1y4LSBAOXKcnWoCL0OgtHU'},
    {name: 'Bandcamp', url: 'https://bigcitysupreme.bandcamp.com/album/super-deluxe'},
    {name: 'Apple Music', url: '#'},
    {name: 'YouTube', url: '#'}
  ];

  return (
    <footer className="bg-gradient-to-t from-black to-gray-900 border-t border-red-600/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <div className="text-2xl font-bold bebas-neue gradient-text">
                BIG CITY SUPREME
              </div>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              Hard rock legends from Edmonton, Alberta. Making noise since 2010, making sense never.
            </p>
            <a 
              href="mailto:bigcitysupreme@gmail.com" 
              className="flex items-center space-x-2 text-gray-400 hover:text-white transition-colors text-sm"
            >
              <SafeIcon icon={FiMail} className="h-4 w-4" />
              <span>bigcitysupreme@gmail.com</span>
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.path} 
                    className="text-gray-400 hover:text-white transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Music Platforms */}
          <div>
            <h3 className="text-white font-semibold mb-4">Listen</h3>
            <ul className="space-y-2">
              {externalLinks.map((link) => (
                <li key={link.name}>
                  <a 
                    href={link.url} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="flex items-center space-x-2 text-gray-400 hover:text-white transition-colors text-sm"
                  >
                    <span>{link.name}</span>
                    <SafeIcon icon={FiExternalLink} className="h-3 w-3" />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4">Get in Touch</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <span className="text-gray-400">General:</span>{' '}
                <a 
                  href="mailto:bigcitysupreme@gmail.com" 
                  className="text-yellow-400 hover:text-yellow-300"
                >
                  bigcitysupreme@gmail.com
                </a>
              </li>
              <li>
                <span className="text-gray-400">Booking:</span>{' '}
                <a 
                  href="mailto:bigcitysupreme@gmail.com" 
                  className="text-yellow-400 hover:text-yellow-300"
                >
                  bigcitysupreme@gmail.com
                </a>
              </li>
              <li>
                <span className="text-gray-400">Press:</span>{' '}
                <a 
                  href="mailto:bigcitysupreme@gmail.com" 
                  className="text-yellow-400 hover:text-yellow-300"
                >
                  bigcitysupreme@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              <p>© {currentYear} Big City Supreme. All rights reserved.</p>
              <p className="mt-1">
                Made with{' '}
                <SafeIcon icon={FiHeart} className="inline h-4 w-4 text-red-500 mx-1" /> 
                in Edmonton, Alberta, Canada
              </p>
            </div>
            <div className="text-gray-400 text-xs text-center md:text-right">
              <p>"We're not just a band, we're a lifestyle choice."</p>
              <p className="mt-1 italic">- Big City Supreme, probably</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;